import React, { ReactElement, ReactNode } from 'react';
import { Box } from '@wds/box';
import { Immutable, safeRest } from '@wds/utils';
import { useHeaderTheme } from '../../theme';

import useStyles from './useStyles';

export type NavBarProps = Immutable<{
  children: ReactNode;
}>;

const NavBar = ({ children, ...rest }: NavBarProps): ReactElement => {
  const theme = useHeaderTheme();
  const classes = useStyles({ theme });

  return (
    <header className={classes.navBar} {...safeRest(rest)}>
      <Box
        display="flex"
        flexDirection="row"
        flexAlign="center"
        flexJustify="space-between"
        className={classes.navBarBox}
      >
        {children}
      </Box>
    </header>
  );
};

export default NavBar;
export { NavBar };
